import theme from '../../theme';

const LoginComponentStyle = {
  root: {
    backgroundColor: theme.palette.background.default,
    minHeight: '100vh',
    padding: '16px 0px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  grid: {
    display: 'flex',
    backgroundImage: 'url(images/new_login_background.jpg)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    padding: '0',
    borderRadius: '5px',
    flexDirection: 'row',
    lineHeight: '1.5',
    minHeight: '600px',
    width: '50%',
    position: 'relative',
    boxShadow: '2px 3px 32px 9px rgba(104, 117, 111, 1)'
  },
  content: {
    height: '100%',
    width: '75%',
    backgroundColor: '#fff',
    clipPath: 'polygon(0 0, 58% 0, 85% 65%, 67% 101%, 0 101%)',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '5px',
    minHeight: '600px',
    justifyContent: 'space-between'
  },
  header: {
    marginTop: '50px',
    marginLeft: '45px'
  },
  title: {
    textAlign: 'left',
    color: '#62c1e2',
    fontWeight: 'bold',
    display: 'block',
    maxWidth: '55%'
  },
  para: {
    textAlign: 'left',
    maxWidth: '55%'
  },
  form: {
    marginTop: '30px',
    marginLeft: '45px',
    maxWidth: '55%'
  },
  loader: {
    textAlign: 'center'
  },
  typographyLabel: {
    color: '#62c1e2'
  },
  inputField: {
    marginTop: theme.spacing(2)
  },
  copyrightFooter: {
    padding: '0px'
  },
  button: {
    marginBottom: theme.spacing(2),
    backgroundColor: '#7bcbe7',
    '&:hover': {
      backgroundColor: '#7bcbe7'
    }
  },
  ssoButton: {
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.button.secondary,
    '&:hover': {
      backgroundColor: theme.palette.button.secondary
    }
  },
  typographyMargin: {
    margin: theme.spacing(2, 0)
  },
  error: {
    color: theme.palette.error.main
  },
  success: {
    color: theme.palette.success.main
  },
  footer: {
    marginLeft: '50px',
    zIndex: '8',
    position: 'relative',
    width: '60%',
    marginBottom: '30px'
  },
  footerImage: {
    marginBottom: '10px'
  },
  logo: {
    height: '40px'
  },
  imgArea: {
    flex: '50%',
    position: 'absolute',
    left: '60%',
    top: '35px'
  },
  customerLogo: {
    maxHeight: '200px',
    width: '100%',
    margin: 'auto',
    paddingTop: '20px'
  },
  hyperlink: {
    cursor: 'pointer',
    color: '#7bcbe7',
    '&:hover': {
      color: '#7bcbe7'
    }
  },
  highlight: {
    color: '#7bcbe7',
    '&:hover': {
      backgroundColor: 'rgb(123, 203, 231)',
      color: 'white !important',
      textDecoration: 'none',
      cursor: 'default'
    }
  },
  infoIcon: {
    fontSize: '1rem',
    marginLeft: '0.5rem'
  },
  line: {
    borderBotton: '1px solid #000',
    width: '75%'
  },
  forgotLink: {
    margin: '0px 0px 1em 0px'
  },
  divider: {
    margin: '0px 0px 1em 0px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  typography: {
    padding: '1rem'
  }
};

export default LoginComponentStyle;
